// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmileFilledSvg from "@fishx/icons-svg/es/asn/SmileFilled";
import FishxIcon from '../components/FishxIcon';

var SmileFilled = function SmileFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SmileFilledSvg
  }));
};

SmileFilled.displayName = 'SmileFilled';
export default React.forwardRef(SmileFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SmileFilled.js
// module id = 4151
// module chunks = 0